import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询待激活组织或会员
export const queryMembers: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMembers', { ...state.members, loading: true });
    const res: IPageData = await $http.post('/v1/data/system/org/activationpagelist', payload);
    commit('setMembers', { data: res.list, total: res.total, pageNum: res.pageNum, pageSize: res.pageSize });
  } catch (e) {
    commit('setMembers', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查询新开订单详情
export const queryOrderDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setOrderDetail', { data: null, loading: true });
    const res = await $http.post('/v1/finance/service/activateorderdetail', payload);
    commit('setOrderDetail', { data: res });
  } catch (e) {
    commit('setOrderDetail', { data: null });
  }
};

// 取消开通组织
export const cancelActive: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/system/org/cancelopen', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
